var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlaKpiNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-SLA_KPI_Normal"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SLA_KPI_Normal",
    "data-name": "SLA  KPI_Normal",
    clipPath: "url(#clip-SLA_KPI_Normal)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SLA_KPI",
    "data-name": "SLA  KPI",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2175",
    "data-name": "Group 2175",
    transform: "translate(22.266 8.148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4765",
    "data-name": "Path 4765",
    d: "M26.871,24.667v8.243H20.54V12.46h6.331v6.857",
    transform: "translate(-19.838 -11.776)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4766",
    "data-name": "Path 4766",
    d: "M27.173,33.922H20.842a.7.7,0,0,1-.7-.7V12.772a.7.7,0,0,1,.7-.7h6.331a.7.7,0,0,1,.7.7v6.84a.7.7,0,1,1-1.4,0V13.473H21.561V32.519h4.911V24.961a.7.7,0,0,1,1.4,0v8.26A.7.7,0,0,1,27.173,33.922Z",
    transform: "translate(-20.14 -12.07)",
    fill: "#6f8b8f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2176",
    "data-name": "Group 2176",
    transform: "translate(0 17.653)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_835",
    "data-name": "Rectangle 835",
    width: 6.331,
    height: 10.944,
    transform: "translate(0.702 0.684)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4767",
    "data-name": "Path 4767",
    d: "M14.483,29.837H8.152a.7.7,0,0,1-.7-.7V18.192a.7.7,0,0,1,.7-.7h6.331a.7.7,0,0,1,.7.7V29.135A.7.7,0,0,1,14.483,29.837ZM8.871,28.416h4.911V18.876H8.871Z",
    transform: "translate(-7.45 -17.49)",
    fill: "#6f8b8f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2177",
    "data-name": "Group 2177",
    transform: "translate(11.124 12.076)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_836",
    "data-name": "Rectangle 836",
    width: 6.331,
    height: 16.521,
    transform: "translate(0.719 0.702)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4768",
    "data-name": "Path 4768",
    d: "M20.823,32.234H14.492a.7.7,0,0,1-.7-.7V15.012a.7.7,0,0,1,.7-.7h6.331a.7.7,0,0,1,.7.7V31.532A.7.7,0,0,1,20.823,32.234Zm-5.612-1.421h4.911v-15.1H15.211v15.1Z",
    transform: "translate(-13.79 -14.31)",
    fill: "#6f8b8f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4769",
    "data-name": "Path 4769",
    d: "M24.452,19.214a.7.7,0,0,1-.7-.7v-.491a.7.7,0,1,1,1.4,0v.491A.7.7,0,0,1,24.452,19.214Z",
    transform: "translate(4.847 0.004)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2179",
    "data-name": "Group 2179",
    transform: "translate(2.477 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_94",
    "data-name": "Line 94",
    y1: 8.822,
    x2: 22.256,
    transform: "translate(0.697 0.649)",
    fill: "#b4c164"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2178",
    "data-name": "Group 2178"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4770",
    "data-name": "Path 4770",
    d: "M9.56,17.165a.7.7,0,0,1-.246-1.35L28.641,8.151a.705.705,0,1,1,.509,1.315L9.823,17.13a1.318,1.318,0,0,1-.263.053Z",
    transform: "translate(-8.863 -6.993)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4771",
    "data-name": "Path 4771",
    d: "M21.086,11.539,23.8,8.119,19.49,7.47Z",
    transform: "translate(-0.851 -7.47)",
    fill: "#6f8b8f"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlaKpiNormal);
export default __webpack_public_path__ + "static/media/SLA _KPI_Normal.516c12b58db46e965735a6bc71821d30.svg";
export { ForwardRef as ReactComponent };